import styled from "styled-components";
import * as DesignSystem from '../../assets/styles/StyleTypes';

export const Form = styled.form`
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 600px;
    overflow-y: auto;
    padding: 0 10px;
    @media (max-width: 960px) {
        width: 100vw;
        overflow-y: hidden;
        padding: 0;
    }
    @media (max-width: 620px) {
        width: 100vw;
        overflow-y: hidden;
    }
`;

export const Small = styled.small`
    font-size: 10px;
    font-weight: 400;
    margin: 5px 0 0 0;
    color: #FFE5E5;
    font-family: Roboto, sans-serif;
    &.white-theme {
        /* color: ${(props) => props.theme.colors.textErrorInput}; */
        color: ${DesignSystem.Colors.TOAST_WARNING};
        font-weight: 700;
    }
`;

export const DivLogo = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    & img {
        width: 199px;
        height: 120px;
        @media (max-width: 960px) {
            width: 140px;
            height: 84px;
        }
    }
    margin-top: 50px;
    margin-bottom: 60px;
`;

export const PhoneInputStyled = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;

    .PhoneInput{                                                                                                         
        display: flex;
        justify-content: center;
        flex-direction: row;                                                                                                                                                                                                                                                                                  
        align-items: center;         
    }
    .PhoneInputInput{
        height: 36px; 
        width: 212px;
        padding-left: 10px;
        border: none;
        border-bottom-right-radius: 6px;
        border-top-right-radius: 6px;
        box-shadow: 0 0 0 0;
        outline: 0;

        ::placeholder {
        color: #A6A6A6;
        font-family: Roboto, sans-serif;
        }
    }
    .PhoneInputCountry{
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        background-color: #E5E5E5;
        padding: 0 8px;
        height: 39px;
        border-bottom-left-radius: 6px;
        border-top-left-radius: 6px;
        justify-content: center;
    }
    .PhoneInputCountryIconImg{
       height: 26px;
       width: 26px;
       border-radius: 100%;
       object-fit: cover;
       color: #004687;
    }
    .PhoneInputCountryIcon{
        height: 26px;
        width: 26px;
    }
    .PhoneInputCountrySelect{
        width: 20px;
        background: none;
        border: none;
        color: #333333;
        cursor: pointer;
        box-shadow: 0 0 0 0;
        outline: 0;
    }

    @media (max-width: 620px) {
        width: 100%;
        .PhoneInput {
            width: -webkit-fill-available;
        }
        .PhoneInputInput {
            width: 100%;
        }
    }
    @media (max-width: 500px) {
        .PhoneInput {
            width: -webkit-fill-available;
        }
        .PhoneInputInput {
            width: 100%;
        }
    }
`;

export const DivInput = styled.div`
    width: 90%;
    display: flex;
    gap: 20px;
    margin: 5px 0px 5px 0px;

    @media (max-width: 620px) {
        width: 80%;
    }
    @media (max-width: 500px) {
        width: 80%;
        flex-direction: column;
    }
    @media (max-width: 370px) {
        width: 70%;
    }

`;

export const DivInputRadioButton = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-around;
    gap: 20px; 
    margin-top: 32px;
    color: white;
`;

export const DivButtons = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 20px;

    @media (max-width: 960px) {
        width: auto;
    }
`;

export const DivQuestions = styled.div`
    display: flex;
    width: 100%;  
    height: 16px;
    justify-content: end;

    & div{
        display: flex;
        align-items: center;
        gap: 5px;

        label {
            color: #F8F9FA;
            margin: 0;
            font-family: Roboto, sans-serif;
            font-weight: normal;
            cursor: pointer;
        }
    }
    
    & a {
        color: #F8F9FA;
        font-size: 12px;
        text-decoration: underline;
        font-family: Roboto, sans-serif;
    }
`;

export const TextConfirm = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    letter-spacing: 0.4px;
    margin-top: 140px;
    padding: 0px 65px;
    opacity: 1;
    color: #F8F9FA;
    font-size: 20px;
    font-weight: bold;
    font-family: Roboto, sans-serif;
`;

export const Text = styled.div`
    width: 100%;
    font-size: 18px;
    color: #F8F9FA;
    font-family: Roboto, sans-serif;
`;

export const TextUserConfirmation = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    letter-spacing: 0.4px;
    margin-top: 80px;
    padding: 0px 50px;
    opacity: 1;
    color: #F8F9FA;
    font-size: 20px;
    font-weight: bold;
    font-family: Roboto, sans-serif;
    margin-bottom: 80px;
`;

export const Label = styled.label`
  font-size: 14px;
  font-weight: 500;
  margin: 0 0 10px 0;
  letter-spacing: 0px;
  color: ${DesignSystem.Colors.HIGH_PURE};
  font-family: Roboto, sans-serif;
  font-weight: normal;
`;

export const Arrow = styled.div`
    padding-top: 20px;
    padding-left: 20px;
    display: flex;
    align-items: left;
    justify-content: left;

    svg {
        color: white;
        width: 30px;
        height: 30px;
        cursor: pointer;
    }
`;

export const Container = styled.div`
    border-radius: 10px;
    opacity: 1;
    background-color: #F8F9FA;
    /* gap: 5px; */
    width: 100%;
    height: auto;
    margin-bottom: 30px;
    display: flex;
    cursor: pointer;

    :hover {
        .title {
            font-weight: 900;
        }

        .arrow {
            background: linear-gradient(90deg, #F8F9FA, #D8D8D8);

            svg.small {
            color: #B4B4B4; 
            }
            svg.big {
                color: #B4B4B4;
                opacity: 1;
            }
        }
    }
`;

export const Title = styled.div`
    letter-spacing: 0.24px;
    color: #004687;
    opacity: 1;
    font-weight: 600;
    font-size: 1rem;
    font-family: Roboto, sans-serif;
    padding-top: 20px;
    padding-left: 10px;

    @media screen and (max-width: 768px) {
        font-size: 12px;
    }
`;

export const Subtitle = styled.div`
    letter-spacing: 0.2px;
    color: #333333;
    opacity: 1;
    font-weight: 500;
    font-size: 13px;
    font-family: Roboto, sans-serif;
    padding-top: 10px;
    padding-left: 10px;
    margin-bottom: 10px;
`;

export const Content = styled.div`
    display: block;
    width: 500px;
`;

export const Icon = styled.div`
    height: 80px;
    width: 80px;
    align-items: center;
    display: flex;
    justify-content: center;
    padding-left: 5px;
`;

export const Arrow2 = styled.div`
    display: flex;
    width: 70px;
    align-items: center;
    justify-content: center;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;

    svg {
        transition: 300ms ease;

        &.small {
            color: ${DesignSystem.Colors.LOW_LIGHT};
            width: 20px;
            height: 20px;
            transform: rotate(180deg);
            cursor: pointer;
        }
        &.big {
            color: ${DesignSystem.Colors.LOW_LIGHT};
            width: 30px;
            height: 30px;
            transform: rotate(180deg);
            cursor: pointer;
            margin-left: -15px;
            opacity: 0;
        }
    }
`;

export const TextNewPlatform = styled.div`
    letter-spacing: 0.18px;
    color: #F8F9FA;
    opacity: 1;
    font-size: 12px;
    font-weight: 500;
    font-family: Roboto, sans-serif;
    margin-bottom: 40px;
`;

export const ColorInput = styled.div`
    margin-bottom: 10px;
    margin-top: 10px;
    display: flex;

    input{
        color: #004687 !important;
        background-color: ${(props) => props.theme.colors.backgroundInput} !important;
        width: 200px !important;
    }
`;